import {
  verifyMaybe_default
} from "./chunk-M5FJK2RG.mjs";
import {
  isMaybe_default
} from "./chunk-KQ65L4I5.mjs";

// src/monet-utils/verifyMaybeObj.ts
import { Maybe } from "monet";
function verifyKeys(obj) {
  return Object.keys(obj).reduce((acc, item) => {
    const x = obj[item];
    return {
      ...acc,
      [item]: isMaybe_default(x) ? verifyMaybe_default(x) : x
    };
  }, {});
}
function verifyMaybeObj(obj) {
  return isMaybe_default(obj) ? verifyMaybe_default(obj).map(verifyKeys) : Maybe.fromUndefined(obj).map(verifyKeys);
}
var verifyMaybeObj_default = verifyMaybeObj;

export {
  verifyMaybeObj_default
};
//# sourceMappingURL=chunk-P23R7W4B.mjs.map